const buttonConstants = {
  INVITE_BUTTON: {
    title: 'Invite'
  },
  REGION_SELECTION: {
    title: 'Select'
  },
  RESET_BUTTON: {
    title: 'Reset'
  },
  CANCEL_BUTTON: {
    title: 'Cancel'
  },
  FILTER_BUTTON: {
    title: 'Filter'
  },
  APPLY_FILTERS_BUTTON: {
    title: 'Apply Filters'
  },
  BACK_BUTTON: {
    title: 'Back'
  },
  DOWNLOAD_BUTTON: {
    title: 'Download (.xls)'
  },
  ADD_BUTTON: {
    title: 'Add'
  },
  REMOVE_BUTTON: {
    title: 'Remove'
  },
  REFRESH_BUTTON: {
    title: 'Refresh'
  },
  CLOSE_BUTTON: {
    title: 'Close'
  },
  UPLOAD_TO_KPHC_BUTTON: {
    title: 'Upload to KPHC'
  }
};
export default buttonConstants;
